import React from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Logo from '@/components/logo/Logo'
import SelectLang from '@/components/selectLang'
import { Row, Col } from 'antd'
import {
  clearAuthentication
  // redirectURL
} from '@/utils/authHelp'
import { modalConfirm } from '@/utils/modalUtils'
import { formatMessage } from '@/utils/common'
import {
  showLang
  // defaultIdToken
} from '@/utils/default'

import './Header.less'

const Header = props => {
  const userName = useSelector(state => state.commonStore.userName) || ''
  const showLogoutModal = () => {
    modalConfirm({ content: formatMessage('languageObj.loginLocale.logoTip') }, () => {
      handelLogoutOk()
    })
  }

  const handelLogoutOk = () => {
    logout()
  }

  const logout = () => {
    clearAuthentication()
    props.history.push('/login')
    // let id_token = localStorage.getItem(defaultIdToken)
    // if (id_token) {
    //   clearAuthentication()
    //   window.location.href = `${process.env.REACT_APP_OKTA_LOGOUT_URL}${id_token}&post_logout_redirect_uri=${redirectURL}`
    // } else {
    //   clearAuthentication()
    //   props.history.push('/login')
    // }
  }

  const renderUser = () => {
    return (
      <div className="user-container">
        <span className="header-item">{userName}</span>
        <span onClick={() => showLogoutModal()} className="header-item header-link">
          {formatMessage('languageObj.loginLocale.logout')}
        </span>
      </div>
    )
  }
  return (
    <div className="gnav">
      <div className="gnav-bar">
        <Row type="flex" justify="space-between" align="middle">
          <Col span={16}>
            <Logo link="/" title="Consumer Return Optimization Platform" />
          </Col>
          <Col span={4}></Col>
          <Col span={4} className="tool-bar">
            {/* {props.fullDom} */}
            {props.authenticated && renderUser()}
            {showLang ? <SelectLang /> : null}
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default withRouter(Header)
